import React, { PureComponent } from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import TooltipMaterial from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import classnames from 'classnames';

const arrowGenerator = () => ({
  '&[x-placement*="bottom"] $arrow': {
    top: 0,
    left: 0,
    marginTop: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '0 1em 1em 1em',
      borderColor: 'transparent transparent var(--background-color) transparent',
    },
  },
  '&[x-placement*="top"] $arrow': {
    bottom: 0,
    left: 0,
    marginBottom: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '1em 1em 0 1em',
      borderColor: 'var(--background-color) transparent transparent transparent',
    },
  },
  '&[x-placement*="right"] $arrow': {
    left: 0,
    marginLeft: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 1em 1em 0',
      borderColor: 'transparent var(--background-color) transparent transparent',
    },
  },
  '&[x-placement*="left"] $arrow': {
    right: 0,
    marginRight: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 0 1em 1em',
      borderColor: 'transparent transparent transparent var(--background-color)',
    },
  },
});

const styles = (theme) =>
  createStyles({
    arrow: {
      position: 'absolute',
      width: '3em',
      height: '3em',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
    },
    popper: {
      '--background-color': theme.custom.palette.colorSupportSlate,
      opacity: 1,
      ...arrowGenerator(),
      width: (props) => props.width,
    },
    tooltip: {
      fontSize: 11,
      backgroundColor: theme.custom.palette.colorSupportSlate,
    },
  });

class TooltipV1 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      arrowRef: false,
    };
  }

  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };

  renderTitle() {
    const { classes, hideArrow, title } = this.props;

    if (!title) return '';

    return (
      <>
        {title}
        {!hideArrow && <span className={classes.arrow} ref={this.handleArrowRef} />}
      </>
    );
  }

  render() {
    const { classes, title, className, ...custom } = this.props;
    const { arrowRef } = this.state;

    return (
      <TooltipMaterial
        title={this.renderTitle()}
        classes={{
          tooltip: classnames(classes.tooltip, className),
          popper: classes.popper,
        }}
        PopperProps={{
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: Boolean(arrowRef),
                element: arrowRef,
              },
            },
          },
        }}
        {...omit(custom, ['backgroundColor', 'hideArrow', 'width'])}
      />
    );
  }
}

TooltipV1.propTypes = {
  backgroundColor: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hideArrow: PropTypes.bool,
  title: PropTypes.any.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  placement: PropTypes.string,
};

TooltipV1.defaultProps = {
  backgroundColor: undefined,
  hideArrow: false,
  className: '',
  width: 'auto',
};

export default withStyles(styles)(TooltipV1);
